import * as Yup from "yup";
import moment from "moment";

const today = moment().format("YYYY-MM-DD");

export const validationSchema = [
    Yup.object().shape({
        User: Yup.object().shape({
            FirstName: Yup.string()
                .trim()
                .matches(/^[a-zA-Z ']+$/, "Incorrect format")
                .max(20, "Must be 20 characters or less")
                .required("Required"),
            MiddleName: Yup.string()
                .trim()
                .matches(/^[a-zA-Z ']+$/, "Incorrect format")
                .max(20, "Must be 20 characters or less")
                .required("Required"),
            FamilyName: Yup.string()
                .trim()
                .matches(/^[a-zA-Z ']+$/, "Incorrect format")
                .max(20, "Must be 20 characters or less")
                .required("Required"),
            MotherName: Yup.string()
                .trim()
                .matches(/^[a-zA-Z ']+$/, "Incorrect format")
                .max(20, "Must be 20 characters or less"),
            DateOfBirth: Yup.date()
                .required("Required")
                .test("Is date greater", "DOB cannot be greater than today's date", (value) => {
                    if (!value) return true;
                    return moment(today).diff(value) > 0;
                })
                .typeError("Invalid Date!"),
            Gender: Yup.string().required("Required"),
            BloodType: Yup.string().required("Required"),
            Identity: Yup.object().shape({
                IdentityID: Yup.string()
                    .trim()
                    .matches(/^[a-zA-Z0-9\s]+$/, "Incorrect format")
                    .max(20, "Must be 20 characters or less"),
                IdentityImageUri: Yup.string(),
            }),
            MaritalStatus: Yup.string().required("Required"),
        }),
        Employee: Yup.object().shape({
            Speciality: Yup.string()
                .trim()
                .matches(/^[a-zA-Z ']+$/, "Incorrect format")
                .max(100, "Must be 100 characters or less")
                .required("Required"),
            RoleID: Yup.string().required("Required"),
        }),
    }),
    Yup.object().shape({
        User: Yup.object().shape({
            Address: Yup.object().shape({
                Street: Yup.string().trim().matches(/^[a-zA-Z0-9.\s]+$/,"Incorrect format").max(50,"Must be 50 characters or less").required("Required"),
                City: Yup.string().trim().matches(/^[a-zA-Z\s]+$/,"Incorrect format").max(50,"Must be 50 characters or less").required("Required"),
                CountryCode: Yup.string().trim().required("Required"),
                Zip: Yup.string().trim().matches(/^([0-9]{5}(?:-[0-9]{4})?)?$/, "Zip code format is 00000-0000"),
                Additional: Yup.string().trim().matches(/^[a-zA-Z0-9().,\s"-]*$/,"Incorrect format").max(200,"Must be 200 characters or less"),
            }),
        }),
    }),
    Yup.object().shape({
        User: Yup.object().shape({
            Insurance: Yup.object().shape({
                InsuranceNb: Yup.string()
                    .trim()
                    .matches(/^[a-zA-Z0-9\s]+$/, "Incorrect format")
                    .max(20, "Must be 20 characters or less").required("Required"),
                InsuranceCompany: Yup.string()
                    .trim()
                    .matches(/^[a-zA-Z ']+$/, "Incorrect format").required("Required"),
                InsuranceCountry: Yup.string().trim().required("Required"),
                InsurancePolicy: Yup.string().trim().matches(/^[a-zA-Z0-9\s]+$/, "Incorrect format").max(40, "Must be 40 characters or less").required("Required"),
                IssuedDate: Yup.date().typeError("Invalid format").required("Required"),
                ExpiryDate: Yup.date().typeError("Invalid format").required("Required").min(Yup.ref("IssuedDate"), "Expiry Date should be after the Issued Date"),
                Active: Yup.boolean().required("Required"),
            }),
        }),
    }),
    Yup.object().shape({
        User: Yup.object().shape({
            Contact: Yup.object().shape({
                PrimaryEmail: Yup.object().shape({
                    Email: Yup.string().trim().email("Invalid Email").required("Required"),
                }),
                SecondaryEmail: Yup.object().shape({
                    Email: Yup.string().trim().email("Invalid Email"),
                }),
                PrimaryPhone: Yup.object().shape({
                    Phone: Yup.string()
                        .trim()
                        .matches(/^\+(?:[0-9] ?){6,14}[0-9]$/, "Incorrect format")
                        .required("Required"),
                    CountryCode: Yup.string().trim().required("Required"),
                }),
                SecondaryPhone: Yup.object().shape({
                    Phone: Yup.string()
                        .trim()
                        .matches(/^\+(?:[0-9] ?){6,14}[0-9]$/, "Incorrect format"),
                    CountryCode: Yup.string().trim(),
                }),
            }),
        }),
    }),
    Yup.object().shape({
        Employee: Yup.object().shape({
            Availability: Yup.object().shape({
                Daysinfo: Yup.object().shape({
                    Monday: Yup.array().of(
                        Yup.object().shape({
                            TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
                            TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
                        })
                    ),
                    Tuesday: Yup.array().of(
                        Yup.object().shape({
                            TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
                            TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
                        })
                    ),
                    Wednesday: Yup.array().of(
                        Yup.object().shape({
                            TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
                            TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
                        })
                    ),
                    Thursday: Yup.array().of(
                        Yup.object().shape({
                            TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
                            TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
                        })
                    ),
                    Friday: Yup.array().of(
                        Yup.object().shape({
                            TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
                            TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
                        })
                    ),
                    Saturday: Yup.array().of(
                        Yup.object().shape({
                            TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
                            TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
                        })
                    ),
                    Sunday: Yup.array().of(
                        Yup.object().shape({
                            TimeFrom: Yup.date().required("Required").typeError("Invalid Date"),
                            TimeTo: Yup.date().required("Required").typeError("Invalid Date"),
                        })
                    ),
                }),
            }),
        }),
    }),
    Yup.object().shape({
        OldPassword: Yup.string()
            .required("Required")
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
                "Must contain at least 8 characters, including 1 uppercase, 1 number and 1 special character"
            )
            .min(8, "Must be at least 8 characters")
            .max(30, "Must be 30 characters or less"),
        NewPassword: Yup.string()
            .required("Required")
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
                "Must contain at least 8 characters, including 1 uppercase, 1 number and 1 special character"
            )
            .min(8, "Must be at least 8 characters")
            .max(30, "Must be 30 characters or less"),
        NewPasswordConfirmed: Yup.string()
            .required("Required")
            .trim()
            .oneOf([Yup.ref("NewPassword"), null], "Passwords do not match")
            .max(30, "Must be 30 characters or less"),
    }),
];
